import { render, staticRenderFns } from "./StatisticalProgramming.vue?vue&type=template&id=8e2b248a&"
import script from "./StatisticalProgramming.vue?vue&type=script&lang=js&"
export * from "./StatisticalProgramming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports